import { render, staticRenderFns } from "./e-button-template-upload.vue?vue&type=template&id=63fba5d8&scoped=true&lang=pug"
import script from "./e-button-template-upload.vue?vue&type=script&lang=js"
export * from "./e-button-template-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fba5d8",
  null
  
)

export default component.exports